export const FULL_SCREEN_WIDGET_ID_URL_PARAM = 'fullscreenWidgetId';
